import React from 'react';
import {
  useAction,
  useFilterSettingsStore,
  useProjectsOverviewStore,
} from 'src/StoreDataProvider';
import Pagination from '../Pagination';
import ProjectList from '../ProjectList/ProjectList';
import { ProjectListAndPaginationProps } from './projectListAndPagination.types';

const ProjectListAndPagination: (
  props: ProjectListAndPaginationProps
) => JSX.Element = () => {
  const { numberOfPages } = useProjectsOverviewStore();
  const { page } = useFilterSettingsStore();
  const { setPage } = useAction();

  return (
    <>
      <ProjectList />
      <Pagination
        currentPage={page}
        numberOfPages={numberOfPages}
        onChange={num => {
          setPage(num);
        }}
      />
    </>
  );
};

export default ProjectListAndPagination;
